import api from "@/services/api";

const normalizeTemplatesResponse = (response) => {
  const data = Array.isArray(response?.data) ? response.data : [];
  return data
    .map((item) => item?.item)
    .filter((item) => item && item.template_uid);
};

const coerceCategory = (category) => ({
  categoryUid: category.categoryUid || category.category_uid,
  name: category.name,
  budgetAmount: Number(category.budgetAmount ?? category.budget_amount ?? 0),
});

export default {
  namespaced: true,
  state: {
    templatesByAcctUid: {},
    loadingByAcctUid: {},
    errorByAcctUid: {},
  },
  getters: {
    getTemplatesByAcctUid: (state) => (acctUid) => {
      return state.templatesByAcctUid[acctUid] || [];
    },
    getLoadingByAcctUid: (state) => (acctUid) => {
      return Boolean(state.loadingByAcctUid[acctUid]);
    },
    getErrorByAcctUid: (state) => (acctUid) => {
      return Boolean(state.errorByAcctUid[acctUid]);
    },
  },
  mutations: {
    setTemplatesByAcctUid: (state, { acctUid, templates }) => {
      state.templatesByAcctUid = {
        ...state.templatesByAcctUid,
        [acctUid]: templates,
      };
    },
    setLoadingByAcctUid: (state, { acctUid, loading }) => {
      state.loadingByAcctUid = {
        ...state.loadingByAcctUid,
        [acctUid]: loading,
      };
    },
    setErrorByAcctUid: (state, { acctUid, hasError }) => {
      state.errorByAcctUid = {
        ...state.errorByAcctUid,
        [acctUid]: hasError,
      };
    },
  },
  actions: {
    async fetchBudgetTemplatesByAcctUid(
      { getters, commit },
      { acctUid, force = false }
    ) {
      try {
        if (!acctUid) {
          return [];
        }

        const cachedTemplates = getters.getTemplatesByAcctUid(acctUid);
        if (!force && cachedTemplates.length > 0) {
          return cachedTemplates;
        }

        commit("setLoadingByAcctUid", { acctUid, loading: true });
        commit("setErrorByAcctUid", { acctUid, hasError: false });

        const response = await api.get("/budget-templates", {
          params: {
            filter: [`acctUid:eq:${acctUid}`],
          },
        });

        const templates = normalizeTemplatesResponse(response);
        commit("setTemplatesByAcctUid", { acctUid, templates });

        return templates;
      } catch (error) {
        console.error("Error fetching budget templates:", error);
        commit("setErrorByAcctUid", { acctUid, hasError: true });
        return [];
      } finally {
        commit("setLoadingByAcctUid", { acctUid, loading: false });
      }
    },
    async createBudgetTemplate(
      { dispatch },
      { acctUid, userId, name, categories }
    ) {
      const payload = {
        acctUid,
        userId,
        name,
        categories: (categories || []).map(coerceCategory),
      };

      const createdTemplate = await api.post("/budget-templates", payload);
      await dispatch("fetchBudgetTemplatesByAcctUid", { acctUid, force: true });
      return createdTemplate;
    },
    async updateBudgetTemplate(
      { dispatch },
      { templateUid, acctUid, userId, name, categories }
    ) {
      const payload = {
        acctUid,
        userId,
        name,
        categories: (categories || []).map(coerceCategory),
      };

      const updatedTemplate = await api.put(
        `/budget-templates/${templateUid}`,
        payload
      );
      await dispatch("fetchBudgetTemplatesByAcctUid", { acctUid, force: true });
      return updatedTemplate;
    },
  },
};
